import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=010778ed&"
var script = {}
import style0 from "./Header.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports